/*
 * Declare global namespace and any supporting methods/members that are referenced on the page 
 * (before the primary scripts are loaded).
 */
( function() {
	if( typeof window.SYR == 'undefined' ) { window.SYR = {}; }

	window.SYR.videoModalRegions = [];

	window.SYR.registerVideoModals = function( regionId ) {
		if( regionId && regionId.length && regionId !== '#' ) {
			window.SYR.videoModalRegions.push( regionId );
		}
	};
} )();